import React, { useState } from "react";
import { Play, X, Film } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function WalkthroughPlayer({ module }) {
  const [open, setOpen] = useState(false);
  if (!module?.has_media) return null;
  const url = `${BACKEND}/api/training/media/${module.media_path}`;
  const isVideo = (module.media_type || "").startsWith("video");
  return (
    <div className="mt-2" data-testid={`walkthrough-${module.key}`}>
      {!open ? (
        <button
          onClick={() => setOpen(true)}
          data-testid={`walkthrough-play-${module.key}`}
          className="inline-flex items-center gap-1.5 text-xs text-accent hover:underline font-medium"
        >
          <Play className="h-3.5 w-3.5" /> Watch 10-sec walkthrough
        </button>
      ) : (
        <div className="relative rounded-md overflow-hidden border border-border bg-black/30 mt-1 animate-in fade-in duration-300">
          <button
            onClick={() => setOpen(false)}
            data-testid={`walkthrough-close-${module.key}`}
            className="absolute top-1.5 right-1.5 z-10 h-6 w-6 grid place-items-center rounded-full bg-black/60 text-white hover:bg-black/80 transition-colors"
            aria-label="Close walkthrough"
          >
            <X className="h-3.5 w-3.5" />
          </button>
          <div className="absolute top-1.5 left-1.5 z-10 inline-flex items-center gap-1 rounded-full bg-black/55 text-white/90 text-[9px] px-2 py-0.5">
            <Film className="h-2.5 w-2.5" /> Silent preview · loops
          </div>
          {isVideo ? (
            <video src={url} autoPlay muted loop playsInline preload="metadata"
              className="w-full block" data-testid={`walkthrough-media-${module.key}`} />
          ) : (
            <img src={url} alt={`${module.label} walkthrough`} loading="lazy"
              className="w-full block" data-testid={`walkthrough-media-${module.key}`} />
          )}
        </div>
      )}
    </div>
  );
}
